export default __webpack_public_path__ + "static/Plots0026-d5f22e3483be5a857117ef919699f30b.jpg";